import {FiX} from "react-icons/fi";

import {Card} from "@/components/card/Card.tsx";
import {CDNImage} from "@/components/cdnImage/CDNImage.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ThirdPartyService} from "@/lib/queries/checks.ts";

import styles from "@/pages/checks/components/form/fields/components/ThirdPartyGroup.module.scss";

interface ThirdPartyComponentv2Props {
  variant?: "component" | "subComponent";
  group: ThirdPartyService;
  body?: string;
  index: number;
  className?: string;
  remove: (index: number) => void;
}

export const ThirdPartyComponentv2 = ({
  variant = "component",
  group,
  body,
  index,
  className,
  remove,
}: ThirdPartyComponentv2Props) => {
  return (
    <Card variant={variant === "component" ? "cloudStatusComponent" : "cloudStatusSubComponent"} className={className}>
      <div className="d-flex align-items-center justify-content-between column-gap-2 h-100 flex-wrap-reverse">
        <div className="d-flex align-items-center">
          <CDNImage className={styles.componentIcon} alt={`${group.group} logo`} src={group.logo_src} />
          <div className={variant === "component" ? "pulseTextBodySmallMedium" : "pulseTextBodySmall"}>{body}</div>
        </div>
        <Icon icon={FiX} className="cursor-pointer ms-auto" onClick={() => remove(index)} role="button" />
      </div>
    </Card>
  );
};
